import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { MasterViewPage } from './MasterPage';


export const Logout = () => {
    return <MasterViewPage>
        <Container><Typography variant='h2'>Déconnexion en cours...</Typography></Container>
    </MasterViewPage >;
};
